import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

//Pass Json to insert
export const usePostJson = (url, data, method, auth) => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const {token} = useAuth();
    console.log("UU: "+JSON.stringify(data))
    console.log("LL: "+url)
    console.log("Active Token: "+token)

    useEffect(() => {
        const myFetch = async(url, data) => {
        setLoading(true);
        const res = await fetch(url, {
          method: method, 
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth || token}` // Use the provided auth token or fallback to the context token
          },
          body: JSON.stringify(data)
        })
            .catch((err) => {
                setError(err)
                setLoading(false)
            });

        try{  
          const ans = await res.json();
          setResponse(ans)
        } catch (err) {
          setError(err);
        }
            
        setLoading(false);
        //setResponse(ans);
        }
        myFetch(url, data);    }, [url, data, method])
    return { response, loading, error }
}